module.exports = __webpack_public_path__ + "static/media/cat_dev.efb7aa14.png";